// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.property-media h2,
.property-description h2,
.property-location h2,
.property-amenities h2,
.property-overview h2{
    background-color: var(--color-light-gray);
    color: var(--color-dark-gray);
    text-align: center;
    padding: 1rem 0;
}

.nearby-amenities h3,
.neighborhood-information h3{
 background-color: var(--color-light-blue);
 padding: 1rem 0;
 color: var(--color-dark-gray);
 text-align: center;
}
.property-detail-page {
    max-width: 1600px;
    margin: 0 auto;
    padding: 20px;
}

.property-gallery {
    margin-bottom: 30px;
}

.main-image {
    width: 100%;
    height: 500px;
    overflow: hidden;
    margin-bottom: 10px;
}

.main-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.thumbnail-strip {
    display: flex;
    gap: 10px;
    overflow-x: auto;
}

.thumbnail-strip img {
    width: 100px;
    height: 75px;
    object-fit: cover;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s;
}

.thumbnail-strip img.active {
    opacity: 1;
    border: 2px solid #007bff;
}

.property-header {
    text-align: center;
    margin-bottom: 30px;
}

.property-header h1 {
    margin-bottom: 10px;
    color: #333;
}

.property-address {
    font-size: 1.2rem;
    color: #666;
    margin-bottom: 1rem;
}

.property-price {
    font-size: 28px;
    font-weight: bold;
    color: #2c5282;
}

.property-featured-image {
    margin-bottom: 30px;
    border-radius: 8px;
    overflow: hidden;
    max-width: 1200px;
    margin: 0 auto;
}

.property-featured-image img {
    width: 100%;
    height: auto;
    object-fit: cover;
}

.property-quick-info {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-bottom: 40px;
    padding: 20px;
    background: #f7fafc;
    border-radius: 8px;
}

.info-item {
    text-align: center;
}

.info-item .label {
    display: block;
    font-size: 14px;
    color: #4a5568;
    margin-bottom: 5px;
   
}

.info-item .value {
    display: block;
    font-size: 24px;
    font-weight: bold;
    color: #2d3748;
    text-transform: capitalize;
}

.property-details-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 2rem;
    margin-top: 2rem;
}

.property-section {
    margin-bottom: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid #eee;
}

.property-section h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
}

.features-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    list-style: none;
    padding: 0;
    width: fit-content;
    margin: 0 auto;
}

.sidebar {
    position: sticky;
    top: 20px;
}

.property-overview,
.property-description {
    margin-bottom: 40px;
}
.overview-details {
    display: grid;
    gap: 15px;
}

.overview-details > div {
    padding: 10px;
    background: #f7fafc;
    border-radius: 4px;
}

.contact-agent {
    background: #f7fafc;
    padding: 30px;
    border-radius: 8px;
    margin-top: 40px;
}

.contact-form {
    display: grid;
    gap: 15px;
    max-width: 600px;
    margin: 0 auto;
}

.contact-form input,
.contact-form textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 16px;
}

.contact-form textarea {
    height: 120px;
}

.contact-form button {
    padding: 12px 24px;
    background: #2c5282;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.contact-form button:hover {
    background: #2a4365;
}


@media (max-width: 768px) {
    .property-details-grid {
        grid-template-columns: 1fr;
    }
    
    .main-image {
        height: 300px;
    }
    
    .property-quick-info {
        grid-template-columns: repeat(2, 1fr);
    }

    .gallery-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 0.5rem;
    }
}

@media (max-width: 480px) {
    .property-quick-info {
        grid-template-columns: 2fr;
    }
}

.property-location {
    margin: 40px 0;
}

.property-map {
    margin: 2rem 0;
}

.location-details-container {
    display: flex;
    gap: 2rem;
    margin-top: 2rem;
}

.neighborhood-information,
.nearby-amenities {
    flex: 1;
    min-width: 0; /* Prevents flex item from overflowing */
}

.nearby-amenities ul {
    list-style: none;
    padding: 0;
    margin: 1rem 0;
}

.nearby-amenities li {
    padding: 0.5rem 0;
    border-bottom: 1px solid #eee;
}
.property-contact{
    background-color: #c0c0c0;
    padding: 2rem;
}
.contact-image img{
    max-width: 400px;
    max-height: 400px;
}
/* Responsive layout for mobile devices */
@media (max-width: 768px) {
    .location-details-container {
        flex-direction: column;
    }
}

.property-amenities {
    margin: 2rem 0;
}

.amenities-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1rem;
    list-style: none;
    padding: 0;
}

.amenities-list li {
    padding: 0.5rem;
    background-color: #f5f5f5;
    border-radius: 4px;
}

.amenity-item .dashicons {
    font-size: 2rem;
    display:block;
    text-align: center;
    margin-bottom: 1rem;
    width: 100%;
}
.amenity-item h5{
    text-align: center;
}
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1rem;
    margin: 1rem 0;
}

.gallery-item {
    aspect-ratio: 4/3;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.gallery-item:hover {
    transform: scale(1.02);
}

.gallery-item:hover::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    pointer-events: none;
}

.gallery-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./assets/css/PropertyDetail.css"],"names":[],"mappings":"AAAA;;;;;IAKI,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;CAEC,yCAAyC;CACzC,eAAe;CACf,6BAA6B;CAC7B,kBAAkB;AACnB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;;AAEtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;;IAEI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,2DAA2D;QAC3D,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,OAAO;IACP,YAAY,EAAE,wCAAwC;AAC1D;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA,yCAAyC;AACzC;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".property-media h2,\n.property-description h2,\n.property-location h2,\n.property-amenities h2,\n.property-overview h2{\n    background-color: var(--color-light-gray);\n    color: var(--color-dark-gray);\n    text-align: center;\n    padding: 1rem 0;\n}\n\n.nearby-amenities h3,\n.neighborhood-information h3{\n background-color: var(--color-light-blue);\n padding: 1rem 0;\n color: var(--color-dark-gray);\n text-align: center;\n}\n.property-detail-page {\n    max-width: 1600px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n.property-gallery {\n    margin-bottom: 30px;\n}\n\n.main-image {\n    width: 100%;\n    height: 500px;\n    overflow: hidden;\n    margin-bottom: 10px;\n}\n\n.main-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.thumbnail-strip {\n    display: flex;\n    gap: 10px;\n    overflow-x: auto;\n}\n\n.thumbnail-strip img {\n    width: 100px;\n    height: 75px;\n    object-fit: cover;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s;\n}\n\n.thumbnail-strip img.active {\n    opacity: 1;\n    border: 2px solid #007bff;\n}\n\n.property-header {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.property-header h1 {\n    margin-bottom: 10px;\n    color: #333;\n}\n\n.property-address {\n    font-size: 1.2rem;\n    color: #666;\n    margin-bottom: 1rem;\n}\n\n.property-price {\n    font-size: 28px;\n    font-weight: bold;\n    color: #2c5282;\n}\n\n.property-featured-image {\n    margin-bottom: 30px;\n    border-radius: 8px;\n    overflow: hidden;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.property-featured-image img {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n}\n\n.property-quick-info {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    margin-bottom: 40px;\n    padding: 20px;\n    background: #f7fafc;\n    border-radius: 8px;\n}\n\n.info-item {\n    text-align: center;\n}\n\n.info-item .label {\n    display: block;\n    font-size: 14px;\n    color: #4a5568;\n    margin-bottom: 5px;\n   \n}\n\n.info-item .value {\n    display: block;\n    font-size: 24px;\n    font-weight: bold;\n    color: #2d3748;\n    text-transform: capitalize;\n}\n\n.property-details-grid {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 2rem;\n    margin-top: 2rem;\n}\n\n.property-section {\n    margin-bottom: 2rem;\n    padding-bottom: 2rem;\n    border-bottom: 1px solid #eee;\n}\n\n.property-section h3 {\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n}\n\n.features-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1rem;\n    list-style: none;\n    padding: 0;\n    width: fit-content;\n    margin: 0 auto;\n}\n\n.sidebar {\n    position: sticky;\n    top: 20px;\n}\n\n.property-overview,\n.property-description {\n    margin-bottom: 40px;\n}\n.overview-details {\n    display: grid;\n    gap: 15px;\n}\n\n.overview-details > div {\n    padding: 10px;\n    background: #f7fafc;\n    border-radius: 4px;\n}\n\n.contact-agent {\n    background: #f7fafc;\n    padding: 30px;\n    border-radius: 8px;\n    margin-top: 40px;\n}\n\n.contact-form {\n    display: grid;\n    gap: 15px;\n    max-width: 600px;\n    margin: 0 auto;\n}\n\n.contact-form input,\n.contact-form textarea {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 4px;\n    font-size: 16px;\n}\n\n.contact-form textarea {\n    height: 120px;\n}\n\n.contact-form button {\n    padding: 12px 24px;\n    background: #2c5282;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.contact-form button:hover {\n    background: #2a4365;\n}\n\n\n@media (max-width: 768px) {\n    .property-details-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .main-image {\n        height: 300px;\n    }\n    \n    .property-quick-info {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .gallery-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n        gap: 0.5rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .property-quick-info {\n        grid-template-columns: 2fr;\n    }\n}\n\n.property-location {\n    margin: 40px 0;\n}\n\n.property-map {\n    margin: 2rem 0;\n}\n\n.location-details-container {\n    display: flex;\n    gap: 2rem;\n    margin-top: 2rem;\n}\n\n.neighborhood-information,\n.nearby-amenities {\n    flex: 1;\n    min-width: 0; /* Prevents flex item from overflowing */\n}\n\n.nearby-amenities ul {\n    list-style: none;\n    padding: 0;\n    margin: 1rem 0;\n}\n\n.nearby-amenities li {\n    padding: 0.5rem 0;\n    border-bottom: 1px solid #eee;\n}\n.property-contact{\n    background-color: #c0c0c0;\n    padding: 2rem;\n}\n.contact-image img{\n    max-width: 400px;\n    max-height: 400px;\n}\n/* Responsive layout for mobile devices */\n@media (max-width: 768px) {\n    .location-details-container {\n        flex-direction: column;\n    }\n}\n\n.property-amenities {\n    margin: 2rem 0;\n}\n\n.amenities-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 1rem;\n    list-style: none;\n    padding: 0;\n}\n\n.amenities-list li {\n    padding: 0.5rem;\n    background-color: #f5f5f5;\n    border-radius: 4px;\n}\n\n.amenity-item .dashicons {\n    font-size: 2rem;\n    display:block;\n    text-align: center;\n    margin-bottom: 1rem;\n    width: 100%;\n}\n.amenity-item h5{\n    text-align: center;\n}\n.gallery-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 1rem;\n    margin: 1rem 0;\n}\n\n.gallery-item {\n    aspect-ratio: 4/3;\n    overflow: hidden;\n    position: relative;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n}\n\n.gallery-item:hover {\n    transform: scale(1.02);\n}\n\n.gallery-item:hover::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.1);\n    pointer-events: none;\n}\n\n.gallery-item img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
